(function () {
  if (window.lgRestockSignupAttached) return;
  window.lgRestockSignupAttached = true;
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var widget = form.closest('[data-back-in-stock]');
    if (!widget || widget.hidden) return;
    event.preventDefault();
    var status = widget.querySelector('[data-lg-restock-status]');
    var submit = form.querySelector('button[type="submit"]');
    var email = form.querySelector('[data-back-in-stock-email]');
    var variant = form.querySelector('[data-back-in-stock-variant-id-input]');
    var product = form.querySelector('[name="lg_product_id"]');
    if (!email || !variant || !product || !form.reportValidity()) return;
    if (status) { status.hidden = false; status.textContent = 'Deine Anmeldung wird geprüft …'; }
    if (submit) submit.disabled = true;
    var body = new URLSearchParams();
    body.set('email', email.value.trim());
    body.set('variant_id', variant.value);
    body.set('product_id', product.value);
    body.set('website', (form.querySelector('[name="website"]') || {}).value || '');
    try {
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 12000);
      var response;
      try {
        response = await fetch('https://n8n-1n4b.srv1934631.hstgr.cloud/webhook/lg-restock-signup-2026', {
          method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store', signal: controller.signal,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
          body: body.toString()
        });
      } finally { clearTimeout(timeout); }
      var answer = await response.json();
      if (!response.ok || !answer.ok) throw new Error('not_registered');
      if (status) status.textContent = 'Bitte prüfe dein E-Mail-Postfach und bestätige die Anmeldung über den Link.';
      email.value = '';
    } catch (error) {
      if (status) status.textContent = 'Die Anmeldung konnte leider nicht gespeichert werden. Bitte versuche es später erneut oder kontaktiere uns unter info@lorenzos-gusto.com.';
    } finally {
      if (submit) submit.disabled = false;
    }
  }, true);
})();
